import $ from 'jquery';
import Swiper from 'swiper';

function SwiperCtrl() {
	this.init();
}

SwiperCtrl.prototype.init = function() {
  this.front();
}

SwiperCtrl.prototype.front = function () {
  const $target = $('.front-case-swiper');
  if ($target.length === 0) return;

  var swiper = new Swiper('.front-case-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 32,
    // slidesPerGroup: 2,
    centeredSlides: true,
    loop: true,
    loopFillGroupWithBlank: true,
  });
}

export default SwiperCtrl;